<app-header></app-header>
<!-- Hero section -->
<owl-carousel-o [options]="customOptions" class="owl-btn-center-lr hero-slider-one">
    <ng-template carouselSlide *ngFor="let slide of slideStore; let i = index">
        <!-- Slider Item -->
        <div class="section-fullscreen bg-image" [ngClass]="{ 'bg-overlay-gradient': slide.hasOverlay }" [style.backgroundImage]="'url(' + slide.image + ')'">
            <div class="bg-dark-06">
                <div class="container z-index-1">
                    <div class="position-middle">
                        <div class="row">
                            <div class="col-12 col-sm-10 col-md-9">
                                <h1 class="display-5 fw-medium font-family-syne">{{slide.title}}</h1>
                                <a class="button button-lg button-radius button-white-2 mt-3" routerLink="/contact">Start Work</a>
                            </div>
                        </div><!-- end row -->
                    </div>
                </div><!-- end container -->
            </div>
        </div>
    </ng-template>
</owl-carousel-o>
<!-- end owl-carousel -->
<!-- end Hero section -->

<!-- Features section -->
<div class="section">
    <div class="container">
        <div class="row g-4 icon-5xl">
            <div class="col-12 col-md-4" *ngFor="let service of services">
                <div class="mb-2">
                    <i [class]="service.icon + ' text-dark'"></i>
                </div>
                <h5 class="fw-normal font-family-syne">
                    {{ service.title }}
                </h5>
                <p>
                    {{ service.description }}
                </p>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Features section -->

<!-- About section -->
<div class="section pt-0">
    <div class="container">
        <div class="row align-items-center g-5">
            <!-- About Image -->
            <div class="col-12 col-lg-6">
                <div class="box-backdrop">
                    <img src="assets/images/about/about-img-3.jpg" alt="about-3">
                </div>
            </div>
            <!-- About Content -->
            <div class="col-12 col-lg-6">
                <h3 class="fw-normal font-family-syne">Your Challenges, Our Solutions - Tailored IT Services for Seamless Growth.</h3>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                <a class="button button-lg button-backdrop-dark mt-4" routerLink="/about-us">About Us</a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Facts section -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/main-bg-1.jpg');">
    <div class="bg-dark-07">
        <div class="container text-center">
            <div class="row g-4">
                <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
                    <h1 class="fw-semi-bold font-family-syne">{{fact.displayedNumber | number:'1.0-0'}}</h1>
                    <h6 class="font-large fw-normal font-family-syne">{{fact.desc}}</h6>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Facts section -->

<!-- Clients section -->
<div class="section">
    <div class="container">
        <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
            <ng-template carouselSlide *ngFor="let brand of brands">
                <div class="client-box">
                    <a routerLink="/">
                        <img [src]="brand.image" [alt]="brand.alt">
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- Blog section -->
<div class="section pt-0">
    <div class="container">
        <div class="mb-5">
            <div class="row align-items-end">
                <div class="col-12 col-sm-6">
                    <h2 class="fw-normal font-family-syne m-0">Latest Posts</h2>
                </div>
                <div class="col-12 col-sm-6 text-sm-end">
                    <a class="button-text-1 font-family-syne" routerLink="/blog-grid">Read All Blogs</a>
                </div>
            </div>
        </div>
        <owl-carousel-o [options]="blogOptions">
            <ng-container *ngFor="let blog of blogItems">
                <ng-template carouselSlide>
                    <div>
                    <div class="hoverbox-6 border-radius">
                        <a [routerLink]="blog.link">
                        <img [src]="blog.image" [alt]="blog.alt">
                        <div class="content top bg-dark border-radius">
                            <span class="font-family-poppins font-small fw-normal uppercase m-0 text-white">
                            {{ blog.category }}
                            </span>
                        </div>
                        </a>
                    </div>
                    <div class="p-3">
                        <h5 class="fw-normal m-0">
                        <a class="text-link-1" [routerLink]="blog.link">{{ blog.title }}</a>
                        </h5>
                        <span>{{ blog.date }}</span>
                    </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Blog section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg');">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row g-4">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="display-4 font-family-syne fw-medium">Ready to Elevate Your IT Strategy?</h2>
                    <p>Maecenas nec odio et ante tincidunt tempus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt.</p>
                    <a class="button button-lg button-radius button-outline-white mt-4" routerLink="/contact">Call Us</a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Testimonial section -->
<div class="section border-top">
    <div class="container">
        <div class="row column-3 spacing-2">
            <div class="col-md-4" *ngFor="let testimonial of testimonials">
                <div class="box-shadow border-radius p-4 p-lg-5">
        
                    <!-- Stars -->
                    <div class="d-block text-golden-yellow mb-3">
                        <i class="bi bi-star-fill" *ngFor="let star of [].constructor(testimonial.rating)"></i>
                    </div>
        
                    <!-- Message -->
                    <p class="font-large">
                        "{{ testimonial.message }}"
                    </p>
        
                    <!-- Client Info -->
                    <div class="d-flex align-items-center mt-3">
                        <div class="d-inline-block me-3">
                            <img class="img-mask-avatar-sm" [src]="testimonial.image" [alt]="testimonial.name">
                        </div>
                        <div class="d-inline-block">
                            <h5 class="fw-normal m-0 line-height-140 font-family-syne">
                                {{ testimonial.name }}
                            </h5>
                            <span class="font-small fw-normal font-family-syne">
                                {{ testimonial.role }}
                            </span>
                        </div>
                    </div>
        
                </div>
            </div>
        </div><!-- end masonry -->
    </div><!-- end container -->
</div>
<!-- end Testimonial section -->